/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rank: NonNullable<unknown> }} Meta_Rank_TierInputs */



/**
* | output |
* | --- |
* | "T{rank}" |
*
* @param {Meta_Rank_TierInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_rank_tier = /** @type {((inputs: Meta_Rank_TierInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Rank_TierInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`T${i?.rank}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Top ${i?.rank}`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`T${i?.rank}`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`T${i?.rank}`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`T${i?.rank}`)
	return /** @type {LocalizedString} */ (`T${i?.rank}`)
});